<template>
  <div class="layouHome">
    <div :class="['navigation-bars', 'blakes']">
      <div class="left-menu">
        <div class="left-menu-item">
          <i
            :class="['iconfont', !menuOpen ? 'icon-toggle' : 'icon-toggle']"
            @click="showAside"
          />
        </div>
      </div>
      <div class="right-menu">
        <div class="user-avator right-menu-item">
          <img v-if="userInfo.headimgurl" class="user-header" :src="userInfo.headimgurl" />
          <img v-else src="@/assets/images/default.jpg" alt="">
        </div>
        <!-- <el-avatar src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar> -->

        <div class="name right-menu-item">{{ userInfo.nickname }}</div>
        <div class="setting right-menu-item">
          <el-dropdown trigger="click">
            <i class="el-icon-setting"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="changePaw"
                >修改密码</el-dropdown-item
              >
              <el-dropdown-item @click.native="logAot"
                >退出登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="stance"></div>
    <div class="menu-ambient" v-if="menuOpen" @click="hideAside">
      <div class="menu-bar" @click.stop="">
        <sideBar></sideBar>
      </div>
    </div>
    <!-- <div class="menu-bar" v-if="menuOpen">
      <sideBar></sideBar>
    </div>-->
    <div class="guidance-content bar">
      <router-view></router-view>
    </div>
    <!-- 修改密码弹框 -->
    <div class="popout model">
      <el-dialog
        title="修改密码"
        width="500px"
        :visible.sync="outerVisible"
        :close-on-click-modal="false"
      >
        <el-form
          v-if="outerVisible"
          :model="ruleForm"
          status-icon
          ref="ruleForm"
          label-width="150px"
          class="demo-ruleForm"
        >
          <el-form-item label="新密码">
            <el-input
              type="password"
              v-model="ruleForm.pass"
              autocomplete="off"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码">
            <el-input
              type="password"
              v-model="ruleForm.checkPass"
              placeholder="请输入确认密码"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <div
            class="row-item footer"
            style="width: 97%; margin-top: 10px; text-align: center"
          >
            <div class="element-list jb-bg btn" @click="submitForm('ruleForm')">
              确认
            </div>
            <div class="element-list btn" @click="resetForm('ruleForm')">
              取消
            </div>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import sideBar from "@/components/sidebar";
import { updatePasw } from "@/api/userApi";
export default {
  data() {
    return {
      userName: {},
      userImg:
        "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
      menuOpen: false,
      outerVisible: false,
      ruleForm: {
        pass: "",
        checkPass: "",
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    },
  },
  components: {
    sideBar,
  },
  methods: {
    hideAside() {
      this.menuOpen = false;
    },
    showAside() {
      this.menuOpen = !this.menuOpen;
    },
    //调整方法
    goEquipment() {
      this.$router.push({ path: "/instaru/equipment" });
    },
    goWarehouse() {
      this.$router.push({ path: "/warehouse/warehousemana" });
    },
    changePaw() {
      this.outerVisible = true;
    },
    submitForm(formName) {
      let that = this;
      if (this.ruleForm.pass.length < 6 && this.ruleForm.checkPass.length < 6) {
        this.$message({
          message: "密码长度不能小于6位",
          type: "warning",
        });
        return;
      }
      if (this.ruleForm.pass != this.ruleForm.checkPass) {
        this.$message({
          message: "两次密码不一致！请重新输入",
          type: "warning",
        });
        return;
      }
      updatePasw({ id: that.userInfo.id, psw: that.ruleForm.pass }).then(
        (res) => {
          that.$message({
            message: res.msg,
            type: "success",
          });
          that.ruleForm.pass = "";
          that.ruleForm.checkPass = "";
          that.outerVisible = false;

          setTimeout(() => {
            that.$router.push({ path: "/login" });
          }, 1000);
        }
      );
    },
    resetForm(formName) {
      this.ruleForm.pass = "";
      this.ruleForm.checkPass = "";
      this.outerVisible = false;
    },
    logAot() {
      this.$store.dispatch("Logout").then(() => {
        setTimeout(() => {
          this.$message.success("退出成功");
          this.$router.replace({ path: "/login" });
          // location.reload(); // 强制刷新
        }, 1000);
      });
      // this.$confirm("确定退出系统?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "info",
      // })
      //   .then(() => {
      //     // this.$store.dispatch("FedLogOut");
      //     // this.$store.commit('SET_PERMS', '')
      //     this.$message({
      //       type: "success",
      //       message: "退出成功!",
      //     });
      //     setTimeout(() => {
      //       this.$router.replace({ path: "/login" });
      //       // location.reload(); // 强制刷新
      //     }, 1000);
      //   })
      //   .catch(() => {
      //     this.$message({
      //       type: "info",
      //       message: "已取消退出",
      //     });
      //   });
    },
  },
};
</script>

<style lang="less" scoped>
// 样式修改
.layouHome {
  height: 100%;
  background-image: url("~@/assets/images/biaogebg.png");
  background-repeat:no-repeat;
  background-size:100% 100%;
  -moz-background-size:100% 100%;
  position: relative;
  .stance{
    width: 100%;
    height: 60px;
    }
  .menu-ambient {
    position: absolute;
    top: 60px;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 2008;
    background: rgba(000, 000, 000, 0.5);
    .menu-bar {
      width: 260px;
      height: 100%;
      background: #333b4d;
      box-shadow: 1px 8px 17px 2px rgba(56, 170, 254, 0.46);
    }
  }
  .navigation-bars {
    position: absolute;
    top: 0;
    left: 0;
    height: 60px;
    width: 100%;
    z-index: 10;
    .left-menu {
      float: left;
      height: 100%;
      line-height: 60px;
      color: #ffffff;
      .left-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        vertical-align: text-bottom;
        i {
          color: #ffffff;
          font-size: 24px;
        }
      }
    }
    .right-menu {
      float: right;
      height: 100%;
      line-height: 60px;
      color: #ffffff;
      .user-avator {
        img {
          width: 40px;
          height: 40px;
          margin-top: 7px;
          border-radius: 50%;
        }
      }
      .setting {
        i {
          color: #ffffff;
          font-size: 24px;
        }
      }
      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        vertical-align: text-bottom;
      }
    }
  }
}

.popout {
  /deep/.el-form-item {
    border: 2px solid #0090f0;
    border-radius: 6px;
    height: 40px;
    line-height: 40px;
    margin: 20px 0;
    text-align: center;
    .el-form-item__label {
      background-image: linear-gradient(#0479b4, #02407e);
      text-align: center;
      color: #74c8fe;
    }
  }
  .footer {
    display: flex;
    justify-content: center;
    color: #74c8fe;
    .element-list {
      width: 150px;
      cursor: pointer;
      border: 2px solid #0090f0;
      border-radius: 6px;
      height: 30px;
      line-height: 30px;
      margin: 10px 0;
      margin-right: 10px;
      text-align: center;
    }
  }
}

.layouHome {
  .blakes {
    background: #2b2f3a;
    box-shadow: 0px 1px 59px 9px rgba(0, 146, 255, 0.36);
  }
  .navigation-bars {
    height: 60px;
    // background: black;
  }
  .guidance-content {
    height: calc(100% - 60px);
    padding: 0 1%;
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layou_bw/layouHome.vue